<template>

    <div class="modal fade gt-md-modal" id="mt-confirm-double-popup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog mt-4">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2>Oops!</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                        <a href="#" onclick="closeDoublePaymentModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                            </svg>

                        </a>
                    </div>
                </div>
                <!-- gt-md-modal-header -->
                <div class="gt-md-modal-content text-center">
                    <div class="mb-4 mt-2">
                        <p class="position-relative d-inline-block">
                            <span id="confirm-text">
                                Hi, we have already received a payment from you, would you like to make another one?
                            </span>
                        </p>
                    </div>
                    <div>
                        <a href="#" @click="CloseModal" class="theme-btn-blue" id="DoublePaymentConfirmCancel">Cancel</a>
                        <a href="#" @click="CloseModal" class="theme-btn-lite mt-2" id="DoublePaymentConfirm">Proceed</a>
                    </div>
                </div>
                <!-- gt-md-modal-content -->
            </div>
        </div>
    </div>
    <section class="min-100vh preview-bg" :class="previewClass">
        <div class="preview-modal-inner w-100 bg-transparent">
            <Form :validation-schema="schema" @submit="onSubmit">
                <div class="preview-modal-btn-right">

                    <a v-if="this.hasSession"
                       href="javascript:void(0)"
                       target="_top"
                       title="if part"
                       @click="moveNexxt('collectionUrlFinal')">
                        <svg width="19"
                             height="28"
                             viewBox="0 0 16 28"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 26L14 14L2 2"
                                  stroke="#1E2437"
                                  stroke-width="4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                        </svg>
                    </a>

                    <a v-else
                       href="javascript:void(0)"
                       target="_top"
                       title="else part"
                       @click="moveNexxt('#collectionUrlFinal')">
                        <svg width="16"
                             height="28"
                             viewBox="0 0 16 28"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 26L14 14L2 2"
                                  stroke="#1E2437"
                                  stroke-width="4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>

                <div class="preview-modal-btn-left bdsign">
                    <a v-if="hasGroupCard" href="javascript:void(0)" @click="showHideDve('showGroupCard');">
                        <svg width="16"
                             height="28"
                             viewBox="0 0 16 28"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2L2 14L14 26"
                                  stroke="#1E2437"
                                  stroke-width="4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                        </svg>
                    </a>
                    <a v-else href="javascript:void(0)" @click="showHideDve('firstpagediv');">
                        <svg width="16"
                             height="28"
                             viewBox="0 0 16 28"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2L2 14L14 26"
                                  stroke="#1E2437"
                                  stroke-width="4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>

                <div class="row no-gutters m-0 min-100vh">
                    <div class="col-lg-6 bg-lite" id="backScreen" v-if="!backscreen">
                        <div class="mt-contribute-left mt-48">

                            <a href="#" class="contributor-back-arrow" @click="showHideDve('firstpagediv');">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
                                    <path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10"></path>
                                    <path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10"></path>
                                </svg>
                            </a>

                            <div class="mt-contribute-left-content text-center">
                                <h2><span v-html="collectionTitle"></span></h2>

                             


                                <input id="Ctype" value="1" style="display: none" />
                                <div v-if="contributionSettingType === 2" class="mt-how-many">
                                    <input id="Ctype" value="2" style="display:none" />
                                    <input id="txtfixedAmount" value="fixedAmountToKeep" style="display:none" />
                                    <div class="mt-aamount">
                                        <h1 id="new-amount">${{ fixedAmount }}</h1>
                                        <p>This collection has a set contribution amount.</p>
                                    </div>

                                    <div class="mt-how-many">
                                        <h3>How many times would you like to contribute?</h3>
                                        <div class="mt-4">
                                            <div class="quantity d-flex justify-content-between align-items-center">
                                                <a href="#" class="quantity-left-minus" @click="changecounter(-1);">
                                                    <i class="fas fa-minus"></i>
                                                </a>
                                                <input type="number" id="how-many" name="quantity" value="1" class="counter" @input="changecounter(0)" disabled>
                                                <a href="#" class="quantity-right-plus" @click="changecounter(1);">
                                                    <i class="fas fa-plus"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="mt-how-many">

                                    <div class="green-notification max-400 ml-auto mr-auto" v-if="collectionType === 7">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0">

                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 14H10V10H9M10 6H10.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z" stroke="#36ADB4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>

                                            </div>
                                            <div class="flex-grow-1 text-left">
                                                <p>You'll be able to choose an eGift Card, flowers, plants or gift boxes for any occasion. Our most popular gift is the AnyCard which lets the recipient choose gifts cards they really want.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <h3>AMOUNT OF CONTRIBUTION</h3>
                                    <div class="mt-2 mb-2">

                                        <div class="set-value">
                                            <span>USD$</span>

                                            <Field :disabled=isDisabled v-model="contributionAmount"
                                                   @blur="verifyAmount"
                                                   validateOnBlur
                                                   :rules="verifyAmount"
                                                   type="number"
                                                   name="contributionAmount"
                                                   placeholder="00.00"
                                                   class="form-control" />
                                        </div>


                                    </div>
                                    <ErrorMessage name="contributionAmount"
                                                  class="text-danger" />

                                    <p class="font-12">
                                        The amount you give won’t be seen by other contributors
                                    </p>
                                </div>

                                <div class="mt-closes">
                                    <h3>CLOSES</h3>
                                    <p>{{ this.closeDate }}</p>
                                </div>
                                <div v-if="collectionhastargetamount" class="mt-target">
                                    <h3>TARGET</h3>
                                    <p>${{ this.collectiontargetamount }}</p>
                                </div>
                                <div v-if="showTotalCollected === '3'" class="mt-target">
                                    <h3>TOTAL COLLECTED</h3>
                                    <p v-if="calculatedSoFar">${{ this.calculatedSoFar }}</p>
                                    <p v-else>$0</p>
                                </div>
                            </div>
                            <!-- mt-contribute-left-content -->
                            <div class="mt-logo-footer">
                                <div class="w-75 m-auto">
                                    <a href="#paymentDetails"
                                       id="sign-card-with-payment"
                                       class="theme-btn-lite d-block d-md-none mobile-payment" @click="mobilepayment">Continue to payment details</a>
                                </div>
                                <svg viewBox="0 0 136 58" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.509 30.914c4.142 0 7.509-3.397 7.509-7.509V8.21h-2.98v1.579S10.34 8 7.48 8C3.248 8 0 11.367 0 15.598c0 4.232 3.248 7.569 7.48 7.569 2.86 0 4.558-1.788 4.558-1.788v2.026a4.508 4.508 0 01-4.53 4.53c-1.22 0-2.383-.447-3.217-1.312L2.205 28.71c1.4 1.43 3.278 2.205 5.304 2.205zm-.03-10.727c-2.503 0-4.5-2.116-4.5-4.589 0-2.503 1.997-4.618 4.5-4.618s4.589 2.115 4.589 4.618c0 2.473-2.086 4.59-4.589 4.59zM18.453 22.958h2.98v-8.283c.09-2.086 1.699-3.844 3.755-3.844.774 0 1.52.268 2.145.685l1.132-2.86A6.843 6.843 0 0025.485 8c-2.77 0-4.052 1.967-4.052 1.967V8.209h-2.98v14.75zM36.243 23.167c4.172 0 7.48-3.337 7.48-7.569 0-4.26-3.308-7.598-7.48-7.598-4.172 0-7.48 3.337-7.48 7.598 0 4.232 3.308 7.569 7.48 7.569zm0-2.98c-2.503 0-4.5-2.235-4.5-4.589 0-2.503 2.086-4.618 4.5-4.618s4.5 2.115 4.5 4.618c0 2.473-2.116 4.59-4.5 4.59zM53.26 23.167c4.171 0 6.853-2.712 6.853-6.883V8.209h-2.98v8.313c0 2.384-1.49 3.904-3.874 3.904-2.383 0-3.873-1.52-3.873-3.904V8.21h-2.98v8.075c0 4.171 2.682 6.883 6.853 6.883zM63.543 30.706h2.98v-9.327s1.698 1.788 4.559 1.788c4.171 0 7.479-3.337 7.479-7.598 0-4.232-3.308-7.569-7.48-7.569-2.86 0-4.558 1.788-4.558 1.788v-1.58h-2.98v22.498zm7.539-10.519c-2.563 0-4.589-2.056-4.589-4.618 0-2.474 2.026-4.59 4.589-4.59 2.562 0 4.5 2.116 4.5 4.59 0 2.562-1.938 4.618-4.5 4.618z"></path>
                                    <path d="M27.94 24.031l.354.344c2.045 1.983 4.872 3.212 7.998 3.212 3.126 0 5.953-1.229 7.998-3.212l.354-.344 2.185 2.119-.377.365C43.85 29.04 40.257 30.6 36.292 30.6s-7.558-1.56-10.16-4.084l-.377-.365 2.184-2.119z"
                                          class="text-turquoise-100 fill-current theme-color @previewClass"></path>
                                    <path d="M21.366 49.985h2.98V38.006h2.71v-2.83h-2.71v-6.803h-2.98v6.802h-2.712v2.831h2.712v11.979zM36.246 50.163c4.172 0 7.48-3.337 7.48-7.568 0-4.261-3.308-7.599-7.48-7.599-4.171 0-7.479 3.338-7.479 7.599 0 4.231 3.308 7.568 7.48 7.568zm0-2.98c-2.503 0-4.499-2.234-4.499-4.588 0-2.503 2.086-4.619 4.5-4.619 2.413 0 4.499 2.116 4.499 4.619 0 2.473-2.116 4.589-4.5 4.589zM53.471 57.91c4.142 0 7.51-3.396 7.51-7.508V35.205H58v1.58s-1.699-1.788-4.56-1.788c-4.23 0-7.479 3.367-7.479 7.598s3.248 7.568 7.48 7.568c2.86 0 4.559-1.787 4.559-1.787v2.026a4.508 4.508 0 01-4.53 4.529c-1.221 0-2.383-.447-3.218-1.311l-2.086 2.086c1.401 1.43 3.278 2.205 5.304 2.205zm-.03-10.726c-2.502 0-4.499-2.116-4.499-4.59 0-2.502 1.997-4.618 4.5-4.618s4.588 2.116 4.588 4.619c0 2.473-2.085 4.589-4.588 4.589zM71.197 50.163a7.42 7.42 0 005.334-2.234l-2.176-2.116c-.864.894-1.966 1.37-3.158 1.37-1.997 0-3.785-1.34-4.261-3.337H78.39c0-5.631-3.023-8.85-7.194-8.85-4.172 0-7.45 3.338-7.45 7.599 0 4.231 3.278 7.568 7.45 7.568zm-4.261-9.147c.625-1.788 2.085-3.04 4.171-3.04 2.086 0 3.695 1.341 4.142 3.04h-8.313zM82.894 49.985h2.98V38.006h2.712v-2.83h-2.712v-6.803h-2.98v6.802h-2.711v2.831h2.711v11.979zM91.114 49.955h2.98v-7.747c0-2.355 2.115-4.291 4.469-4.291 2.503 0 4.321 1.936 4.321 4.44v7.598h2.979v-7.45c0-4.171-2.92-7.509-7.091-7.509-3.189 0-4.679 1.967-4.679 1.967v-8.59h-2.98v21.582zM115.854 50.163a7.418 7.418 0 005.333-2.234l-2.175-2.116c-.864.894-1.967 1.37-3.158 1.37-1.997 0-3.785-1.34-4.261-3.337h11.71c0-5.631-3.278-8.85-7.449-8.85-4.172 0-7.45 3.338-7.45 7.599 0 4.231 3.278 7.568 7.45 7.568zm-4.261-9.147c.625-1.788 2.085-3.04 4.171-3.04 2.086 0 3.695 1.341 4.142 3.04h-8.313zM125.988 49.955h2.98V41.67c.089-2.086 1.698-3.844 3.754-3.844.775 0 1.52.268 2.146.686L136 35.652a6.843 6.843 0 00-2.98-.656c-2.771 0-4.052 1.967-4.052 1.967v-1.758h-2.98v14.75z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 bg-white mt-mob-bg  d-md-block" v-bind:class=" { 'd-none': isActive }" id="paymentDetails">
                        <div class="mt-contribute-right mt-48">
                            <div class="mt-contribute-right-content">

                                <div v-if="showPaymentScreen" id="payment-block" class="mt-pay-btn payment-block">
                                    <h2>Payment details</h2>
                                    <stripe-payment :amount="contributionAmount"
                                                    :customer_details="customerDetails"
                                                    :collection_id="this.collectionId"
                                                    :message="message"
                                                    @showLoadScreen="showLoadScreenpayment"
                                                    @hideLoadScreen="hideLoadScreenpayment"
                                                    @DoubleEntryContribution="ShowDoubleEntryPopup"
                                                    :mtDoubleCheck="this.mtdoublecheck"
                                                    ref="StripePaymentDetail" />
                                </div>

                                <div v-if="!showPaymentScreen"
                                     class="mt-contribute-scrollable-block">
                                    <h2 class="position-static">
                                        <a href="javascript:void(0)"
                                           class="d-block d-md-none contributorPayment-back-arrow"
                                           id="backtoContribution">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none" data-v-cf03cfe2=""><path d="M10.3829 18.3652L2 9.98238L10.3829 1.59953" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" data-v-cf03cfe2=""></path><path d="M2.01367 9.98242L21.1838 9.98242" stroke="#1E2437" stroke-width="2" stroke-miterlimit="10" data-v-cf03cfe2=""></path></svg>
                                        </a>
                                        Contribute now
                                    </h2>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group mt-form">
                                                <label>First Name</label>
                                                <Field v-model.trim="customerDetails.firstName"
                                                       name="firstName"
                                                       type="text"
                                                       class="form-control"
                                                       placeholder="First name"
                                                       validateOnBlur />
                                                <ErrorMessage name="firstName" class="text-danger" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mt-form">
                                                <label>Last Name</label>
                                                <Field v-model.trim="customerDetails.lastName"
                                                       name="lastName"
                                                       type="text"
                                                       class="form-control"
                                                       placeholder="Last name"
                                                       validateOnBlur />
                                                <ErrorMessage name="lastName" class="text-danger" />
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-group mt-form">
                                                <label>Email address</label>
                                                <Field v-model="customerDetails.email"
                                                       name="email"
                                                       type="email"
                                                       class="form-control"
                                                       placeholder="xxx@xxxxxx.xxx"
                                                       validateOnBlur />
                                                <ErrorMessage name="email" class="text-danger" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-3 mb-3">
                                        <div class="col-12">
                                            <!--<VueRecaptcha class="mt-3 mb-3" v-if="showRecaptcha"-->
                                            <VueRecaptcha ref="recaptcha"
                                                          :sitekey="siteKey"
                                                          :load-recaptcha-script="true"
                                                          @verify="handleRecaptchaSuccess"
                                                          @error="handleRecaptchaError">
                                            </VueRecaptcha>
                                        </div>
                                    </div>
                                    <!-- Re captcha -->
                                    <div v-show="recaptchaSuccess">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="creditCardDiv">
                                                    <div v-if="collectionQuestionId > 0"
                                                         class="form-group mt-form">
                                                        <label>{{ collectionQuestion }}</label>
                                                        <Field v-model="collectionQuestionAnswer"
                                                               name="question"
                                                               type="text"
                                                               class="form-control"
                                                               placeholder="please answer the question"
                                                               autocomplete="off" />
                                                        <ErrorMessage name="question" class="text-danger" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div v-if="this.contributionAmount > 0" class="mt-cart-total payment-block">

                                                    <p>Subtotal: ${{ contributionAmount }}</p>
                                                    <!--<p>Fees: ${{ (contributionAmount * 0.1).toFixed(2) }}</p>-->
                                                    <p>Total: ${{ contributionAmount }}</p>
                                                </div>
                                                <div v-else class="mt-cart-total payment-block">
                                                    <p>Subtotal: $0</p>
                                                    <p>Total: $0</p>
                                                </div>
                                                <div class="mt-pay-btn payment-block">
                                                    <button id="button" class="">Submit</button>
                                                </div>
                                                
                                                <div class="mt-pay-btn payment-block" v-if="confirmMessege!=''">
                                                    <p class="text-danger">{{confirmMessege}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Popup-->
                    <div class="modal fade gt-md-modal" id="mt-no-of-people-exceed-popup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog mt-4">
                            <div class="modal-content">
                                <div class="gt-md-modal-header">
                                    <h2>Are you sure?</h2>
                                    <div class="gt-modal-close" data-dismiss="modal">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                            <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                            <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                                        </svg>
                                    </div>
                                </div>
                                <!-- gt-md-modal-header -->
                                <div class="gt-md-modal-content text-center">
                                    <div class="mb-4 mt-2">
                                        <p class="position-relative d-inline-block">
                                            <span id="confirm-text">
                                                {{errorMessage}}
                                            </span>
                                        </p>
                                    </div>
                                    <div>
                                        <a href="#" class="theme-btn-blue" data-dismiss="modal">Yes</a>
                                        <a href="#" class="theme-btn-lite mt-2" data-dismiss="modal" @click="UndoAll">No</a>
                                    </div>
                                </div>
                                <!-- gt-md-modal-content -->
                            </div>
                        </div>
                    </div>
                    <!--PopUp-->
                </div>
            </Form>
        </div>
    </section>
</template>

<script>
    import StripePayment from "@/components/Payments/StripePayment";
    import { VueRecaptcha } from "vue-recaptcha";
    import * as Yup from "yup";
    import { Form, Field, ErrorMessage } from "vee-validate";
    import "../../assets/GT_css/site-style-responsive.css";
    import "../../assets/GT_css/site-style.css";
    import "../../assets/GT_css/cs.css";
    import { string } from "yup/lib/locale";

    let totalCollectedContribution = 0;
    export default {
        name: "ContributionPayment",
        components: {
            StripePayment,
            VueRecaptcha,
            Form,
            Field,
            ErrorMessage,
        },
        props: ['collectionId', 'closeDate', 'hasSession', 'mode', 'hasGroupCard', 'message'],
        data() {
            const schema = Yup.object().shape({
                email: Yup.string().required("Email is required").email('Enter a valid email'),
                lastName: Yup.string().required('Last name is required'),
                firstName: Yup.string().required('First name is required'),
                contributionAmount: Yup.number()
                    .typeError('Contribution amount must be more than $ 0 USD')
                    .moreThan(0, "Contribution amount must be more than $0 USD")
                    .lessThan(1001, "Contribution amount must not be more than $ 1000 USD")

            });

            return {
                confirmMessege:"",
                siteKey: "6LcKfugUAAAAANRdbb3_UXUdOq3oFrJI4DKiU2DF", // TODO : We need to store keys like this somewhere more secure - research suggested best practices
                contributionSettingType: 0,
                fixedAmount: 0,
                fixedAmountToKeep: 0,
                showTotalCollected: "",
                calculatedSoFar: 0,
                isActive: true,
                backscreen: false,
                showPaymentScreen: false,
                mtdoublecheck: false,
                isDisabled: false,
                leftAmount: 0,
                collectionTitle: "",
                contributionAmount: "",
                collectionQuestion: "",
                collectionQuestionId: 0,
                collectiontargetamount: 0,
                collectionhastargetamount: false,
                collectionQuestionAnswer: "",
                showRecaptcha: false,
                recaptchaSuccess: false,
                schema,
                customerDetails: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    address: {
                        state: '',
                        city: '',
                        postal_code: '',
                        country: '',
                        line1: ''
                    }
                },
                collectionType:0
            };
        },
        mounted() {
            this.$emit('showLoadScreen');
            this.getContributionPaymentDetails();
            this.$emit('hideLoadScreen');
            this.checkcollstatus();
        },
        methods: {
            UndoAll() {
                $('#how-many').val("1");
                this.fixedAmount = this.fixedAmountToKeep;
                this.contributionAmount = this.fixedAmount;
            },
            showconfrimMessage(msg) {
                this.errorMessage = msg
                $('#mt-no-of-people-exceed-popup').modal({
                    backdrop: 'static',
                    keyboard: false
                })
            },
            changecounter(e) {
                let Amountleft = 0;
                let add = 0;
                let minus = 0;
                if (e == 1) {
                    //add
                    let howmany = '';
                    howmany = $('#how-many').val().toString();
                    add = parseInt(howmany) + 1;
                    //check for target amount
                    Amountleft = parseInt(this.fixedAmount) + parseInt(this.fixedAmountToKeep);
                    if (this.collectionhastargetamount) {
                        //check for remaing target
                        if (this.collectiontargetamount > Amountleft) {
                            this.fixedAmount = Amountleft;
                            this.contributionAmount = this.fixedAmount;
                        } 
                        
                        //else {
                        //    this.$emit("showErrorMessage", `"We're almost at our target, you can only add $${this.leftAmount} to the collection."`)
                        //    this.UndoAll();
                        //}
                    } else {
                        this.fixedAmount = Amountleft;
                        this.contributionAmount = this.fixedAmount;
                    }
                    $('#how-many').val(add.toString());
                    if (add > 5) {
                        this.showconfrimMessage(`"Confirming you are paying for ${add} people at $${this.fixedAmountToKeep} each which means you will be charged $ ${this.fixedAmount}."`);
                    }
                } else if (e == -1) {
                    //minus
                    let howmany = '';
                    howmany = $('#how-many').val().toString();
                    Amountleft = parseInt(this.fixedAmount) - parseInt(this.fixedAmountToKeep);
                    if (Amountleft >= parseInt(this.fixedAmountToKeep)) {
                        this.fixedAmount = Amountleft;
                        this.contributionAmount = this.fixedAmount;
                    } else {
                        this.fixedAmount = parseInt(this.fixedAmountToKeep);
                        this.contributionAmount = this.fixedAmount;
                    }
                    let count = parseInt(howmany);
                    if (count != 0) {
                        minus = parseInt(howmany) - 1;
                        if (minus != 0)
                            $('#how-many').val(minus.toString());
                        if (minus > 5) {
                            this.showconfrimMessage(`"Confirming you are paying for ${minus} people at $${this.fixedAmountToKeep} each which means you will be charged $ ${this.fixedAmount}."`);
                        }


                    }
                }
            },
            async checkcollstatus() {
                fetch('/contributor/CheckStatus?collection=' + this.collection)
                    .then((res) => res.json())
                    .then((data) => {

                        if (data.StatusCode === 200) {
                            this.collectionType = 7;
                        }

                    })
                    .catch(err => console.log(err.message))
            },

            mobilepayment() {
                if (this.contributionAmount) {
                    this.backscreen = true;
                    this.isActive = false;
                } else {
                    this.verifyAmount();
                }

            },
            CloseModal() {
                $('#mt-confirm-double-popup').modal('hide');
            },
            ShowDoubleEntryPopup() {
                $('#mt-confirm-double-popup').modal();
            },
            moveNexxt(state) {
                this.$emit('moveNext', state);
            },
            showHideDve(divId) {
                $("#payment-message").html('');
                const queryString = window.location.search;
                const val = queryString.includes('topup');
                if (val) {
                    this.$emit('showHideDiv', divId)
                }
                else if (this.hasGroupCard) {
                    this.$emit('showHideDiv', "showGroupCard")
                } else {
                    this.$emit('showHideDiv', divId)
                }

            },
            showLoadScreenpayment() {
                this.$emit('showLoadScreen');
            },
            hideLoadScreenpayment() {
                this.$emit('hideLoadScreen');
            },
            onSubmit() {
                this.verifyContribution();
            },
            getContributionPaymentDetails() {
                const urlToCall = `${window.location.origin}/api/Contributions/contribution-amount-details?collectionId=${this.collectionId}`;

                this.axios
                    .get(urlToCall)
                    .then((resp) => {
                        const {
                            AmountSetting,
                            SoFarCalculated,
                            TotalCollectedContribution,
                            CollectionQuestion,
                            CollectionQuestionId,
                            CollectionTarget,
                            HasTargetAmount,
                            CollectionTitle,
                            Amount,
                            ContributionSettingType
                        } = resp.data;
                        this.collectionTitle = CollectionTitle,
                            this.showTotalCollected = AmountSetting;
                        this.collectionhastargetamount = HasTargetAmount;
                        this.collectiontargetamount = CollectionTarget;
                        this.totalCollectedContribution = TotalCollectedContribution;
                        this.calculatedSoFar = SoFarCalculated;
                        this.collectionQuestion = CollectionQuestion;
                        this.collectionQuestionId = CollectionQuestionId;
                        this.fixedAmount = Amount;
                        this.fixedAmountToKeep = Amount;
                        this.contributionSettingType = ContributionSettingType;
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            },
            handleRecaptchaSuccess() {
                this.recaptchaSuccess = true;
                if (this.contributionSettingType == 2) {
                    this.contributionAmount = this.fixedAmountToKeep;
                }
            },
            handleRecaptchaError() {
                this.$emit('showLoadScreen');
                this.$refs.recaptcha.execute();
                this.$emit('hideLoadScreen');
            },
            verifyAmount(val) {
                let inputAmount = 0,estimateTotal=0;
                try {
                    if (this.contributionAmount) {
                        inputAmount = Number.parseInt(this.contributionAmount);
                        this.leftAmount = 2000 - Number.parseInt(this.calculatedSoFar);
                        estimateTotal = Number.parseInt(this.calculatedSoFar) + inputAmount;
                        if (estimateTotal > 2000 && this.leftAmount>0) {
                            this.$emit("showErrorMessage", `" Collections cannot exceed 2000$, you can only add $ ${this.leftAmount} to the collection."`)
                            this.contributionAmount = this.leftAmount;
                            return false;
                        }
                        else if (this.leftAmount == 0) {
                            this.$emit("showErrorMessage", `" Collections cannot exceed 2000$"`);
                            this.contributionAmount = this.leftAmount;
                        }
                    }
                   
                    else {
                   
                        this.contributionAmount = 0;
                        return false;
                    }

                } catch (err) {
                    console.log(err);
                }
            },
            async verifyContribution(s) {
           
                this.$emit('showLoadScreen');
                const urlToCall = `${window.location.origin}/api/Contributions/can-contribute`;

                await this.axios
                    .post(urlToCall, {
                        ContributionAmount: this.contributionAmount,
                        CollectionId: this.collectionId
                    })
                    .then(async (resp) => {
                        
                    const {
                            Item1,  // IsAllowed
                            Item2   // Reason
                        } = resp.data;
 
                        if (Item1) {
                         
                            this.showPaymentScreen = true;
                            this.isDisabled = true;
                            this.$emit('hideLoadScreen');


                            
                        } else {
                            this.$emit('hideLoadScreen');
                          this.confirmMessege= resp.data.Item2;
                        }

                        // handle failure

                    })
                    .catch((err) => {
                        console.log(err);
                        this.isDisabled = false;
                        this.$emit('hideLoadScreen');
                    });
            },
        },
    };
</script>

<style scoped></style>
